module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/$.fails.js
// module id = 11
// module chunks = 0